/**
 * LE PRIX AFFICHÉ EST-IL CELUI QU'ON VA DÉBITER ?
 *
 * ⚠️ CETTE GARDE A CHANGÉ DE NATURE LE 20/09/2026, ET PERSONNE NE DOIT LA CROIRE ÉQUIVALENTE À
 * CELLE D'AVANT.
 *
 * AVANT, elle confrontait une constante du dépôt (« 50 € » dans `config/coaching.ts`) au montant
 * renvoyé par le serveur : elle attrapait une DIVERGENCE ENTRE DEUX SOURCES. Cette classe de
 * défaut a disparu avec la duplication — il n'y a plus qu'une source.
 *
 * DÉSORMAIS, elle confronte le montant RÉELLEMENT AFFICHÉ à l'utilisateur — celui qui était dans
 * l'état du composant au moment du rendu — à celui que l'intention facture. C'est une garde
 * TEMPS-DE-LECTURE CONTRE TEMPS-D'USAGE.
 *
 * CE QU'ELLE ATTRAPE ENCORE :
 *  — un prix changé ENTRE la lecture du catalogue et la création de l'intention, c'est-à-dire un
 *    déploiement pendant qu'une personne a l'écran ouvert. Ce n'est pas théorique : c'est
 *    exactement le moment où l'on déploie un changement de tarif ;
 *  — un catalogue gardé en mémoire devenu périmé ;
 *  — un défaut de rendu qui afficherait autre chose que ce qui a été chargé.
 *
 * CE QU'ELLE N'ATTRAPE PLUS : la divergence dépôt/serveur. C'est le but du lot, pas une perte.
 *
 * ⚠️ ELLE NE VAUT QUE SI ON LUI PASSE LE MONTANT AFFICHÉ. Lui faire relire le catalogue au moment
 * de payer reviendrait à comparer le serveur à lui-même : elle ne vérifierait plus rien, tout en
 * ayant l'air de vérifier quelque chose.
 */

export interface VerdictMontant {
  coherent: boolean;
  /** Code d'incident à remonter, `null` si tout concorde. */
  code: 'coaching_montant_divergent' | null;
}

/**
 * Les deux montants sont EN CENTIMES, des deux côtés. `centimesDepuisAffichage` a disparu avec la
 * dernière chaîne à analyser : il n'y a plus de « 50 € » à convertir, donc plus de format à mal
 * lire — et le code `coaching_montant_illisible` n'a plus de cause possible.
 */
export function verifierMontant(centimesAffiches: number | null, centimesServeur: number): VerdictMontant {
  // Aucun montant affiché : le parcours n'aurait pas dû s'ouvrir. On refuse plutôt que de laisser
  // passer — c'est le même refus que pour une divergence, et pour la même raison.
  if (centimesAffiches === null) return { coherent: false, code: 'coaching_montant_divergent' };
  if (centimesAffiches !== centimesServeur) return { coherent: false, code: 'coaching_montant_divergent' };
  return { coherent: true, code: null };
}
